import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from '../../actions/ModalActions';
import Modal from '../Modal';
import discountApi from './discountApi';

/** Set, change or clear a promotion's code (allowed on active promotions). */
@connect(
    () => ({}),
    dispatch => bindActionCreators({ closeModal }, dispatch)
)
export default class PromotionCodeModal extends Component {
    constructor(props) {
        super(props);
        this.state = { code: props.promotion.code || '', isSaving: false, error: null };
    }

    handleSubmit() {
        this.setState({ isSaving: true, error: null });
        discountApi.setPromotionCode(this.props.promotion.promotion_id, this.state.code.trim() === '' ? null : this.state.code)
            .then(() => {
                this.props.closeModal();
                if (this.props.onDone) {
                    this.props.onDone();
                }
            })
            .catch(error => this.setState({ isSaving: false, error: error.message }));
    }

    render() {
        var actionButton = (
            <button className={`btn btn-success ${this.state.isSaving ? 'disabled' : ''}`} onClick={this.handleSubmit.bind(this)}>
                {this.state.isSaving ? 'Saving...' : 'Save code'}
            </button>
        );
        return (
            <Modal actionButton={actionButton} className="modal-primary" title={`Promotion code for "${this.props.promotion.name}"`}>
                {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
                <p className="text-muted">Upper-case letters, digits, - and _, 3 to 32 characters. Case and spaces are ignored when a prospect enters it. One code per promotion; leave blank to remove it.</p>
                <input className="form-control" value={this.state.code} maxLength={32} placeholder="SPRING26" onChange={e => this.setState({ code: e.target.value })} />
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/discounts/PromotionCodeModal.js